import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import FeaturedCollections from "@/components/FeaturedCollections";
import ProductGrid from "@/components/ProductGrid";
import StylePurpose from "@/components/StylePurpose";
import CastTrailer from "@/components/CastTrailer";
import ClassInAction from "@/components/ClassInAction";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import ProductJsonLd from "@/components/ProductJsonLd";

export default function Landing() {
  const location = useLocation();

  // When the user lands here via `/#shop` (e.g. clicking Shop from /faq or
  // /track), scroll to the requested section once the page has painted.
  useEffect(() => {
    const id = (location.hash || "").replace("#", "");
    if (!id) return;
    const tryScroll = (attempts = 0) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempts < 12) {
        // Sections containing async data (e.g. ProductGrid) may not yet be in
        // the DOM on first mount — poll briefly.
        setTimeout(() => tryScroll(attempts + 1), 120);
      }
    };
    setTimeout(() => tryScroll(), 60);
  }, [location.hash]);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[var(--st-bg)]">
      <ProductJsonLd />
      <Header />
      <main>
        {/* 1. HERO */}
        <Hero />

        {/* 2. MARQUEE STRIP (overlapping bands per design) */}
        <Marquee
          text="THE KNOW IT OWLS · CLASS IS IN SESSION · ROLL CALL · DETENTION NEVER LOOKED THIS GOOD"
          bg="var(--st-maroon)"
          color="#F5EBD0"
          accentBg="var(--st-mustard)"
        />

        {/* 3. FEATURED COLLECTIONS — Streetwear That Schools (vertical label + 2 hero cards) */}
        <FeaturedCollections />

        {/* 4. STORY HEADLINE + PRODUCT GRID (combined per design ref) */}
        <ProductGrid />

        {/* 6. STYLE WITH A PURPOSE */}
        <StylePurpose />

        {/* 7. CAST + TRAILER */}
        <CastTrailer />

        {/* 7b. CLASS IN ACTION — bts stills */}
        <ClassInAction />

        {/* secondary marquee before signup */}
        <Marquee
          text="DROP 01 · KNOW IT OWLS · TUBI TV · WALL OF ENTERTAINMENT · CB3 · SHOP NOW"
          bg="var(--st-mustard)"
          color="var(--st-fg)"
          accentBg="var(--st-maroon)"
          reverse
          testId="marquee-strip-2"
        />

        {/* 8. NEWSLETTER */}
        <Newsletter />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
